import { ActivityIndicator, View, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import React from 'react';
import { scale } from '../Styles';

export const MNOHSFloatingIndicator: React.FC<{
  style?: StyleProp<ViewStyle>;
  padded?: boolean;
  block?: boolean;
}> = props => {
  return (
    <View
      style={[
        styles.topIndicator,
        props.padded && { padding: scale(20) },
        props.block && { position: undefined },
        props.style,
      ]}>
      <ActivityIndicator size={scale(20)} />
    </View>
  );
};

const styles = StyleSheet.create({
  topIndicator: {
    width: '100%',
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    zIndex: 999,
  },
});
